import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '22%',
        height: '100%',
        left: 0
    },
    wrapper: {
        position: 'relative',
        width: '100%',
        height: 'calc(100% - 120px)',
        borderRadius: 20,
        padding: '0 20px',
        background: '#dddddd',
        overflow: 'auto'
    },

    heading: {
        textAlign: 'center',
        padding: '15px 0'
    },
    itemWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 7,
        cursor: 'pointer'
    },
    image: {
        width: '35px'
    },
    paragraph: {
        fontSize: 13
    }
}))
